import { HOVER_CLASS_EXTENSION } from '@/constants/style';
import React, { useMemo, useState } from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { agate } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { PaneProps } from './types';

export const Pane: React.FC<PaneProps> = ({ items }) => {
  const [selectedIdx, setSelectedIdx] = useState(0);

  // Desktop.
  const paneSelectorNodes = useMemo(() => {
    return items.map((item, i) => {
      const isSelected = i === selectedIdx;
      return (
        <li key={item.label}>
          <span
            className={`group mb-4 flex cursor-pointer items-center font-normal text-sky-500 dark:text-sky-400 lg:text-sm lg:leading-6 ${HOVER_CLASS_EXTENSION}`}
            onClick={() => setSelectedIdx(i)}
          >
            <div
              className="dark:group-hover:highlight-white/10 dark:highlight-white/10 min-w-24 mr-4 w-5 sm:mr-1"
              style={{ minWidth: 18 }}
            >
              <img
                src={item.icon}
                width={30}
                height={30}
                style={{ objectPosition: 'center' }}
                alt={`icon-${item.label}`}
              />
            </div>
            <span className={`${isSelected ? 'font-black text-sky-600' : ''}`}>{item.label}</span>
          </span>
        </li>
      );
    });
  }, [items, selectedIdx, setSelectedIdx]);

  // Mobile.
  const dropdownSelectorNodes = useMemo(
    () =>
      items.map((item, i) => {
        return (
          <option value={i} key={item.label}>
            {item.label}
          </option>
        );
      }),
    [items]
  );

  const item = items[selectedIdx];

  return (
    <>
      <div className="w-full xl:hidden">
        <div className="my-3 mx-auto w-72 max-w-full md:w-1/3">
          <select
            className="form-select m-0
      block
      w-full
      appearance-none
      rounded
      border
      border-solid
      border-gray-300
      bg-white bg-clip-padding bg-no-repeat
      px-3 py-1.5 text-base
      font-normal
      text-gray-700
      transition
      ease-in-out
      focus:border-blue-600 focus:bg-white focus:text-gray-700 focus:outline-none"
            onChange={(e) => setSelectedIdx(parseInt(e.target.value))}
            value={selectedIdx}
          >
            {dropdownSelectorNodes}
          </select>
        </div>
        <div className="col-span-3 hidden overflow-hidden rounded-lg border-gray-100 text-xs sm:block md:text-base">
          <SyntaxHighlighter language={item.language} style={agate}>
            {item.codeSnippet}
          </SyntaxHighlighter>
        </div>
        <div className="col-span-3 overflow-hidden rounded-lg border-gray-100 text-xs sm:hidden md:text-base">
          <SyntaxHighlighter language={item.language} style={agate}>
            {item.codeSnippetNarrow || item.codeSnippet}
          </SyntaxHighlighter>
        </div>
      </div>

      <div className="hidden w-full grid-cols-5 items-center gap-1 xl:grid">
        <div className="col-span-1 p-2">
          <ul>{paneSelectorNodes}</ul>
        </div>
        <div className="col-span-4 overflow-hidden rounded-lg border-gray-100 text-xs md:text-base">
          <SyntaxHighlighter language={item.language} style={agate}>
            {item.codeSnippet}
          </SyntaxHighlighter>
        </div>
      </div>
    </>
  );
};
